export const LIMIT_USE_VIRTUAL_LISTS = 200

export const HOUSEKEEPING_COMPLETE_THRESHOLD = 200
export const HOUSEKEEPING_TRASH_THRESHOLD = 300

export const TAGS_MAX = 50
export const TAGS_DISPLAY_LIMIT = 8

export const MAX_LENGTH_TODO_SUMMARY = 500
export const MAX_LENGTH_TODO_DESCRIPTION = 2000
export const MAX_LENGTH_TAG_NAME = 30
export const MAX_LENGTH_PROJECT_NAME = 500
export const MAX_LENGTH_PROJECT_DESCRIPTION = 2000
export const MAX_LENGTH_AREA_NAME = 50
export const MAX_LENGTH_REPEAT = 500
export const MAX_LENGTH_FILTER_NAME = 500

export const MAX_LENGTH_ATTACHMENT_NAME = 500

export const ATTACHMENTS_MAX = 20

export const MAX_STORAGE_BYTES = 5 * 1024 * 1024 * 1024
export const MAX_ATTACHMENT_BYTES = 100 * 1024 * 1024

export const INFINITY = '∞'
export const MAX_FREE_TIER_TODOS = INFINITY
export const MAX_FREE_TIER_PROJECTS = 5
export const MAX_FREE_TIER_AREAS = 1
export const MAX_FREE_TIER_ATTACHMENTS = 0
export const MAX_SUBSCRIPTION_TODOS = INFINITY
export const MAX_SUBSCRIPTION_PROJECTS = INFINITY
export const MAX_SUBSCRIPTION_AREAS = INFINITY

export function isUnderLimit(value, limit) {
  return limit === INFINITY || value < limit
}
